﻿const setCookie = (cname, cvalue, exdays) => {
    window.dataLayer.push({ occ: cvalue, event: 'onconsent' });
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

const getCookie = (cname) => {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

const deleteCookie = (cname) => {
    if (getCookie(cname) !== "") {
        document.cookie = cname + "=" + ";expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/";
    }
}

const debounce = async (cb, delay = 500) => {
    let timeout

    return (...args) => {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
            cb(...args)
        }, delay)
    }
}

const swiperConfig = {
    slidesPerView: 1.2,
    spaceBetween: 24,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    breakpoints: {
        // tablet
        640: {
            slidesPerView: 2.2,
        },
        // desktop
        1024: {
            slidesPerView: 3.2,
        },
    },
};

const adjustPaddingTop = () => {
    const boxElement = document.querySelector('.hero.has-overlay .box');
    const overlayedSections = document.querySelectorAll('.section--overlayed');

    if (boxElement && overlayedSections.length) {
        let boxHeight = boxElement.offsetHeight;
        let offset = window.innerWidth > 1024 ? (boxHeight / 2) : (boxHeight - 60);

        if (overlayedSections.length) {
            overlayedSections.forEach(section => {
                section.style.paddingTop = `${offset}px`;
            })
        }
    }
}

export { setCookie, getCookie, deleteCookie, debounce, swiperConfig, adjustPaddingTop };